import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Mail, Lock, Eye, EyeOff, Rocket, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { useAuthStore } from "../store/authStore";

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login, loginGuest, isLoading } = useAuthStore();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);

  const dest = loc.state?.from?.pathname || "/";

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error("Veuillez remplir tous les champs"); return; }
    try {
      const u = await login(email, password);
      // Isolation : un partenaire atterrit UNIQUEMENT sur son cockpit.
      if (u?.role === "restaurant") { nav("/restaurant-partenaire", { replace: true }); return; }
      nav(dest, { replace: true });
    }
    catch { toast.error("Email ou mot de passe incorrect"); }
  };

  const handleGuest = async () => {
    try { await loginGuest(); toast.success("Bienvenue en mode découverte"); nav("/", { replace: true }); }
    catch { toast.error("Impossible d'ouvrir le mode démo pour le moment"); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10"
      style={{ background: "linear-gradient(160deg,#0B0F16 0%,#0E0B10 40%,#170A06 75%,#1E0A03 100%)" }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 style={{ color: "#E8C98A", fontWeight: 800, letterSpacing: 6, fontSize: 40 }}>LA BASE</h1>
          <p style={{ color: "#E8C98A", fontWeight: 700 }} className="text-sm mt-2">La 1ère plateforme 100% locale 🇨🇭</p>
        </div>

        <button onClick={() => nav("/register")} data-testid="login-goto-register"
          className="w-full h-13 rounded-2xl flex items-center justify-center gap-2 font-bold text-white mb-3 py-3"
          style={{ background: "linear-gradient(90deg,#000,#333)" }}>
          <UserPlus size={20} /> Créer un compte
        </button>

        <button onClick={handleGuest} disabled={isLoading} data-testid="login-guest-btn"
          className="w-full rounded-2xl flex items-center justify-center gap-2 font-bold py-3 mb-5"
          style={{ border: "1.5px solid #f97316", background: "rgba(249,115,22,0.08)", color: "#f97316" }}>
          <Rocket size={20} /> Découvrir l'app maintenant
        </button>

        <div className="flex items-center gap-3 mb-5">
          <div className="flex-1 h-px" style={{ background: "rgba(187,199,189,0.25)" }} />
          <span className="text-xs" style={{ color: "#BBC7BD" }}>Déjà un compte ?</span>
          <div className="flex-1 h-px" style={{ background: "rgba(187,199,189,0.25)" }} />
        </div>

        <form onSubmit={handleLogin} className="space-y-3">
          <div className="flex items-center gap-3 px-4 rounded-xl h-13 py-3" style={{ background: "rgba(0,0,0,0.30)", border: "1px solid rgba(46,108,71,0.55)" }}>
            <Mail size={20} color="#2ECC71" />
            <input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
              autoCapitalize="none" className="flex-1 bg-transparent outline-none text-[15px]" style={{ color: "#F2F2F2" }} />
          </div>
          <div className="flex items-center gap-3 px-4 rounded-xl h-13 py-3" style={{ background: "rgba(0,0,0,0.30)", border: "1px solid rgba(46,108,71,0.55)" }}>
            <Lock size={20} color="#FFB347" />
            <input data-testid="login-password" type={show ? "text" : "password"} placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)}
              className="flex-1 bg-transparent outline-none text-[15px]" style={{ color: "#F2F2F2" }} />
            <button type="button" onClick={() => setShow((v) => !v)} style={{ color: "#BBC7BD" }}>{show ? <EyeOff size={20} /> : <Eye size={20} />}</button>
          </div>
          <button type="submit" disabled={isLoading} data-testid="login-submit"
            className="w-full rounded-xl font-extrabold text-white py-3.5 mt-1" style={{ background: "#D97A1D" }}>
            {isLoading ? "Connexion..." : "Se connecter"}
          </button>
        </form>

        <p className="text-center text-xs mt-6" style={{ color: "#8a8f98" }}>
          Compte de test : client@test.com / test123
        </p>
        <Link to="/" className="block text-center text-sm mt-3" style={{ color: "#BBC7BD" }}>← Retour à l'accueil</Link>
      </div>
    </div>
  );
}
